import React from "react"
import { Table } from "react-bootstrap"

import Text from "../../../../_components/Text"
import Button from "../../../../_components/Button"
import LoadingInput from "../../../../_components/LoadingInput"
import { getStockInfoHistory } from "../../../../api/stocks"
import { formatDate, parseQueryString } from "../../../../utils"
import DatePicker from "react-datepicker";
import moment from 'moment/moment';

export default props => {
    const ref = React.useRef(null)
    const [loading, setLoading] = React.useState(false)
    const [params, setParams] = React.useState({ end_count: 15 })
    const [data, setData] = React.useState([])

    function goToManagerStockItem(product) {
        window.location.href = `/product/${product}?action=manager-stock`
    }

    const stockType = {
        1: {
            text: 'Estoque inicial',
            color: "text-info"
        },
        2: {
            text: 'Entrada',
            color: 'text-success'
        },
        3: {
            text: 'Saída',
            color: 'text-danger'
        },
        4: {
            text: 'Devolução',
            color: "text-danger",

        },
    }

    function onChange(e) {
        setParams({
            ...params,
            [e.target.name]: e.target.value
        })
    }
    function changeDate(name, value) {
        onChange({
            target: { name, value }
        })
    }

    function generateCSV() {
        const delimiter = ';'
        const header = ["Item", "Tipo de movimentação", "Quantidade", "Descrição", "Data"]

        const rows = data.map(x => ([
            x.product_name,
            stockType[x.type].text || '',
            x.quantity,
            x.reason,
            formatDate(x.created_date)
        ]));
        rows.unshift(header);

        // escapa valores para CSV
        const escapeCSV = (val) => {
            if (val === null || val === undefined) return ''
            const s = String(val)
            const needsQuote = new RegExp(`[\"${delimiter}\\r\\n]`).test(s)
            const escaped = s.replace(/"/g, '""')
            return needsQuote ? `"${escaped}"` : escaped
        };

        const csvContent =
            '\uFEFF' +
            rows.map(r => r.map(escapeCSV).join(delimiter)).join('\r\n')

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `movimentacao-estoque-${new Date().toISOString().slice(0, 10)}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
    }

    function onSearch() {
        setData([])
        setLoading(true)

        if (params.start_date) {
            const date = new Date(params.start_date)
            params.start_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        }
        if (params.end_date) {
            const date = new Date(params.end_date)
            params.end_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} 23:59:59`
        }
        getStockInfoHistory(params)
            .then(result => {
                setData(result)
            })
            .finally(() => {
                setTimeout(() => setLoading(false), 1000)
            })
    }

    function init() {
        const path = window.location.href.split("?")
        if (path.length > 1) {
            const query = parseQueryString(path[1])
            if (query.product) {
                setParams({
                    end_count: 10,
                    product_id: query.product
                })// fixa o item
                getStockInfoHistory({
                    product_id: query.product,
                    end_count: 15
                })
                    .then(result => {
                        setData(result)
                    })
                    .finally(() => {
                        setTimeout(() => setLoading(false), 1000)
                    })
            }
        } else {
            onSearch()
        }
    }
    React.useEffect(init, [ref.current])


    return <div
        className="container"
        ref={ref}>
        <div className="row">
            <div className="col-md-12">
                <h1 className="text-center ">
                    Movimentação do estoque
                </h1>
            </div>
        </div>
        <div className="row">
            <div className="col-md-4">
                <div className="form-group">
                    <div className="form-label">
                        <Text>
                            Item
                        </Text>
                    </div>
                    <LoadingInput
                        placeholder="Descrição do item"
                        loading={loading}
                        onChange={onChange}
                        name="product_name" />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <div className="form-label">
                        <Text>
                            Tipo de movimentação
                        </Text>
                    </div>
                    <LoadingInput
                        onChange={onChange}
                        name="type"
                        loading={loading}
                        as="select" >
                        <option value="">
                            Todos
                        </option>
                        <option value="1">
                            Estoque incial
                        </option>
                        <option value="2">
                            Entrada
                        </option>
                        <option value="3">
                            Saída
                        </option>
                        <option value="4">
                            Devolução
                        </option>
                    </LoadingInput>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <div className="form-label">
                        <Text>
                            Resultados
                        </Text>
                    </div>
                    <LoadingInput
                        onChange={onChange}
                        name="end_count"
                        as="select"
                        loading={loading}>
                        {
                            [10, 20, 30, 40, 50, 100, 200, 400].map((n, idx) => {
                                return <option
                                    value={n}
                                    selected={n === params.end_count}
                                    key={`stock-history-filter-range-${n}-${idx}`}>
                                    {n}
                                </option>
                            })
                        }
                    </LoadingInput>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <div className="form-label">
                        <Text>
                            Data inicial
                        </Text>
                    </div>
                    <DatePicker
                        disabled={loading}
                        name="start_date"
                        maxDate={new Date()}
                        selected={moment(params.start_date)}
                        className="form-control"
                        onChange={e => changeDate("start_date", moment(e))}
                        locale={"pt-BR"}
                    />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <div className="form-label">
                        <Text>
                            Data final
                        </Text>
                    </div>
                    <DatePicker
                        disabled={loading}
                        name="end_date"
                        maxDate={new Date()}
                        selected={moment(params.end_date)}
                        className="form-control"
                        onChange={e => changeDate("end_date", moment(e))}
                        locale={"pt-BR"}
                    />
                </div>
            </div>
            <div className="col-12 py-3">
                <Button
                    disabled={loading}
                    onClick={onSearch}>
                    Pesquisar
                </Button>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Tipo de movimentação</th>
                            <th>Quantidade</th>
                            <th>Descrição</th>
                            <th>Data</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((item, idx) => {
                                return <tr key={`stock-item-history-${item.id}${idx}`} >
                                    <td>{item.product_name}</td>
                                    <td className={stockType[item.type].color}>{stockType[item.type].text}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.reason}</td>
                                    <td>{formatDate(item.created_date)}</td>
                                    <td>
                                        <Button onClick={() => goToManagerStockItem(item.product)}>
                                            Gerenciar Estoque
                                        </Button>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </Table>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">

                <Button style={{ cursor: 'pointer' }} onClick={generateCSV} >Exportar resultados</Button>

            </div>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Stocks/History/index.jsx